import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enCommon from "../locales/en/common.json";
import arCommon from "../locales/ar/common.json";

// Bundled catalogs now; backend ir.translation (i18n Phase 2 / gap G8) loads here later
// through the same instance with no component changes.
export const i18nInstance = i18n.createInstance();

void i18nInstance.use(initReactI18next).init({
    resources: {
        en: { common: enCommon },
        ar: { common: arCommon },
    },
    lng: "en",
    fallbackLng: "en",
    ns: ["common"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
});
